import "./style.scss";

import { FC } from "react";

type TextAreaProps = {
    value?: string;
    onChange?: (e: any) => void;
    placeholder: string;
    required?: boolean;
    className?: string;
    errorMessage?: string;
    rows?: number;
    cols?: number;
} & Record<string, any>;

const TextArea: FC<TextAreaProps> = ({rows = 8, cols, value, onChange, placeholder, required, className, errorMessage, ...rest }) => {
    return (
        <div className={`input-box ${className}`}>
            <textarea
                rows={rows}
                cols={cols}
                value={value}
                onChange={onChange}
                required
                {...rest}
            />
            <label>{placeholder}</label>
            {errorMessage && <span className="error-message">{errorMessage}</span>}
        </div>
    );
};

export default TextArea;
